import React, { useEffect, useState } from "react";
import {
  Container,
  Form,
  Button,
  Breadcrumb,
  Alert,
  Card,
} from "react-bootstrap";
import Layout from "../layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import axios from "axios";

const PabrikAddList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  const [kapasitasram, setKapasitasram] = useState("");
  const [kapasitasproduksi, setKapasitasproduksi] = useState("");
  const [memproduksi, setMemproduksi] = useState("");
  const [msg, setMsg] = useState("");

  const savePabrik = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      await axios.post(
        "https://c-greenproject.org:8000/pabrik",
        { kapasitasram, kapasitasproduksi, memproduksi },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate("/data-pabrik");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "admin" && user.role !== "pabrik") {
      navigate("/dashboard");
    }
  }, [isError, user, navigate]);

  return (
    <Layout>
      <Container>
        <Breadcrumb>
          <Breadcrumb.Item href="/data-pabrik">Data Pabrik</Breadcrumb.Item>
          <Breadcrumb.Item active>Add Data Pabrik</Breadcrumb.Item>
        </Breadcrumb>

        <h2 className="mb-4">
          {" "}
          <strong>Add Data Pabrik</strong>
        </h2>

        {msg && <Alert variant="danger">{msg}</Alert>}
        <Card className="p-4 mb-3 shadow">
          <Form onSubmit={savePabrik}>
            <Form.Group className="mb-3" controlId="kapasitasram">
              <Form.Label>Kapasitas RAMP (kg)</Form.Label>
              <Form.Control
                type="number"
                value={kapasitasram}
                onChange={(e) => setKapasitasram(e.target.value)}
                placeholder="Masukkan Kapasitas RAMP"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="kapasitasproduksi">
              <Form.Label>Kapasitas Produksi (kg)</Form.Label>
              <Form.Control
                type="number"
                value={kapasitasproduksi}
                onChange={(e) => setKapasitasproduksi(e.target.value)}
                placeholder="Masukkan Kapasitas Produksi"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="memproduksi">
              <Form.Label>Catatan Produksi Pabrik</Form.Label>
              <Form.Control
                type="text"
                value={memproduksi}
                onChange={(e) => setMemproduksi(e.target.value)}
                placeholder="Masukkan Catatan Produksi"
              />
            </Form.Group>

            <Button variant="success" type="submit">
              Save
            </Button>
          </Form>
        </Card>
      </Container>
    </Layout>
  );
};

export default PabrikAddList;
